import { Injectable } from '@angular/core';
import {
  UserPortfoliosGQL,
  CreatePortfolioGQL,
  DeletePortfolioGQL,
  UpdatePortfolioGQL,
  SetDefaultPortfolioGQL,
  DefaultUserPortfolioGQL,
  UserPortfolioDropdownGQL,
  UserCountriesGQL,
  UserPortfoliosWithAllParksAndTurbinesGQL
} from '../graphql';
import { Observable, ReplaySubject, BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesPortfolioService {

  private newPortfolioTemplate: ReplaySubject<any>;
  public portfolioListUpdate: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private userPortfolioServices: UserPortfoliosGQL,
              private userPortfoioDropdown: UserPortfolioDropdownGQL,
              private createPortfolio: CreatePortfolioGQL,
              private deletePortfolio: DeletePortfolioGQL,
              private updatePortfolio: UpdatePortfolioGQL,
              private userCountries: UserCountriesGQL,
              private setDefaultPortfolio: SetDefaultPortfolioGQL,
              private defaultUserPortfolio: DefaultUserPortfolioGQL,
              private userPortfoliosWithAllParksAndTurbines: UserPortfoliosWithAllParksAndTurbinesGQL) {
                this.newPortfolioTemplate = new ReplaySubject();
              }


  public getDefaultUserPortfolio(): Observable<any> {
    return this.defaultUserPortfolio.watch().valueChanges.pipe(
      filter(result => !result.loading));
  }
  public getUserPortfolioService(): Observable<any> {
    return this.userPortfolioServices.fetch({
      variables: {},
      fetchPolicy: 'network-only'
    }).pipe(map(data => data.data.user));
  }

  public getUserPortfoliosWithParksAndTurbines(): Observable<any>{
    return this.userPortfoliosWithAllParksAndTurbines.subscribe({fetchPolicy: 'network-only'});
  }

  public getUserPortfolioMenuTop(): Observable<any> {
    return this.userPortfoioDropdown.watch({
      variables: {}, fetchPolicy: 'network-only'}).valueChanges.pipe(
        filter(result => !result.loading && !!result.data),
        map(data => data.data.user.user_portfolios));
  }

  public getUserCountries(): Observable<any> {
    return this.userCountries.fetch();
  }
  public createCustomPorfolio(input: any): Observable<any> {
    return this.createPortfolio.mutate({variables: input}).pipe((map((data: any) => {
      this.portfolioListUpdate.next(true);
      return data;
    })));
  }
  public deleteCustomPorfolio(input: any): Observable<any> {
    return this.deletePortfolio.mutate({variables: input}).pipe((map((data: any) => {
      this.portfolioListUpdate.next(true);
      return data;
    })));
  }
  public updateCustomPortfolio(input: any): Observable<any> {
    return this.updatePortfolio.mutate({variables: input}).pipe((map((data: any) => {
      this.portfolioListUpdate.next(true);
      return data;
    })));
  }
  public setDefPortfolio(input: any): Observable<any> {
    return this.setDefaultPortfolio.mutate({variables: input});
  }



  public getNewPortfolio(): Observable<any> {
    return this.newPortfolioTemplate.asObservable();
  }

  public handlePortfolio(portfolio, operation): void {
    this.newPortfolioTemplate.next({portfolio, operation});
  }
}
